import axios from 'axios';
import StopWatch from "../lib/StopWatch"

// ------------------------------------------------------------------------------------------------
// gateway setup
// ------------------------------------------------------------------------------------------------

const axiosInstance = axios.create({
    baseURL: "mbs/index.php",
    headers: {
        "Accept": "application/json"
    }
});

const ACTION_HEADER = "i10-action"
const TOKEN_HEADER = "i10-token"

const LOGIN_TOKEN = "pBh5J5FE9JhfEfWghEnwi0mj2ZuQJwvkXfM8TG1e4vF/g7I/cl+fI9kOx87bwg+QYFIBj2gdLJMcTTub/gJIhZ8fOftr7WZ1SSf/yjNbsek=";

let accessToken = LOGIN_TOKEN;


export const resetAccessToken = () => {
    accessToken = LOGIN_TOKEN;
}

// ------------------------------------------------------------------------------------------------
// call data structure
// ------------------------------------------------------------------------------------------------

export const initialCall = () => {
    return {isRunning: false, isSuccess: false, isError: false, result: null, elapsed: null}
}

export const runningCall = () => {
    return {isRunning: true, isSuccess: false, isError: false, result: null, elapsed: null}
}

export const successCall = (data, elapsed= null) => {
    return {isRunning: false, isSuccess: true, isError: false, result: data, elapsed: elapsed}
}

export const errorCall = (error, elapsed = null) => {
    return {isRunning: false, isSuccess: false, isError: true, result: error, elapsed: elapsed}
}

// ------------------------------------------------------------------------------------------------
// call execution
// ------------------------------------------------------------------------------------------------


export const executeCall = async (action, data) => {

    const stopWatch = new StopWatch();

    const config = {
        headers: {
            [ACTION_HEADER]: action,
            [TOKEN_HEADER] : accessToken,
        }
    };

    try {
        // execute remote call
        stopWatch.start();
        const response = await axiosInstance.post('', data, config);
        stopWatch.stop();

        // check response for errors
        if (response.status !== 200) {
            return errorCall(`${response.status} ${response.statusText}`, stopWatch.elapsed())
        }
        if (!response.data?.payload) {
            return errorCall(response.data, stopWatch.elapsed());
        }
        if (!response.data.payload.result) {
            return errorCall("Call returned an empty/null result.", stopWatch.elapsed())
        }

        // handle server token
        const newToken = response.headers[TOKEN_HEADER];
        if (newToken) {
            accessToken = newToken;
        }

        // return result of successful call
        return successCall( response.data.payload.result, stopWatch.elapsed())

    } catch (error) {

        // TODO MAINTENANCE enhance error handling for Network errors
        // const errorMessage = error.response?.data?.payload
        //    ?? `${error.response?.status ?? 'Network Error'} ${error.response?.statusText ?? ''}`.trim();

        const errorMessage = error.response?.data?.payload || `${error.response.status} ${error.response.statusText}`
        stopWatch.stop();
        return errorCall(errorMessage, stopWatch.elapsed());
    }
};

// ------------------------------------------------------------------------------------------------
// generic entity calls
// ------------------------------------------------------------------------------------------------

export const entityList = async (entityName) => {
    const action = "entity.list";
    const data = { name: entityName };
    return await executeCall(action, data);
};

export const entityCreate = async (entityName, dbValues) => {
    const action = "entity.create";
    const data = { name: entityName, values: dbValues };
    return await executeCall(action, data);
};

export const entityUpdate = async (entityName, dbValues) => {
    const action = "entity.update";
    const data = { name: entityName, values: dbValues };
    return await executeCall(action, data);
};

export const entityDelete = async (entityName, entityId) => {
    const action = "entity.delete";
    const data = { name: entityName, id: entityId };
    return await executeCall(action, data);
};

export const entitySave = async (entityName, dbValues) => {
    if (dbValues.id === null || dbValues.id === undefined) {
        return await entityCreate(entityName, dbValues);
    } else {
        return await entityUpdate(entityName, dbValues);
    }
};

